import { FunctionalComponent } from "preact";
import { UserProvider } from "@authentic/loyalty-pwa/providers";

export const OrderRedirect = () => {
    const user = UserProvider.get();
    let url
    if (user?.token?.access_token && user?.favorite_location?.integration_id) {
        url = `${process.env.OLO_BASE_URL}/login/deltacocheetahdigital/${user.token?.access_token}?next=/menu/del-taco-${user.favorite_location.integration_id}`;
    } else if (user?.token?.access_token) { 
        url = `${process.env.OLO_BASE_URL}/login/deltacocheetahdigital/${user.token?.access_token}?next=/`;
    } else {
        url = 'https://order.deltaco.com/'
    }

    try { 
        window.location.replace(url)
    } catch (e) {
        window.location.href = url
    }
}